import { defineMessages, useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { LoadingSpinner } from '~/eds/src/components/LoadingSpinner/LoadingSpinner';
import { PageOverlay } from '~/eds/src/components/PageOverlay/PageOverlay';
import { Text } from '~/eds/src/components/Text/Text';

const messages = defineMessages({
  addingItems: {
    id: 'AddToGroupOverlay.addingItems',
    defaultMessage: 'Adding items to group...',
    description: 'Message shown while items are being added to a group',
  },
});

interface AddToGroupOverlayProps {
  isVisible: boolean;
}

export const AddToGroupOverlay = ({ isVisible }: AddToGroupOverlayProps) => {
  const { formatMessage } = useIntl();

  return (
    <PageOverlay isVisible={isVisible} disableHideOnClickOutside>
      <Layout align="center" justify="center" spacing={2}>
        <LoadingSpinner />
        <Text>{formatMessage(messages.addingItems)}</Text>
      </Layout>
    </PageOverlay>
  );
};
